import React, { Component } from "react";
import { PageContainer, Content } from "../Drawer/PageContainer";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import RemoveDialog from "../Shared/Remove/RemoveDialog";
import NoRecord from "../../Components/Display/NoRecord";
import { Navigate } from "react-router-dom";
import { MsalContext } from "@azure/msal-react";
import { deleteDirectory } from "../Helpers/DateLakeStorage";
import {
    enabledisableOnRuntime,
    deleteOnRuntime,
} from "../Helpers/DisableDeleteRuntime";
import SaveDialog from "../Shared/Remove/SaveDialog";
import Scrollable from "../Shared/Edit/Scrollable";
import Upgarde from "../Shared/Subscription/Upgrade";
import Loader from "../Shared/Loader/loader";
import { postMessageToRuntime } from "../Helpers/Runtime/runtime";
import { deleteProject, getOrganisationProjects, updateProject } from "../../API/Project/project";
import { getAppUserAndRoles } from "../../API/Project/project";
import { getOrganizationUsers } from "../../API/Organization/organization";
import NoAccessComponent from "../Shared/Error/NoAccess";
import { withTranslation } from "react-i18next";
import { getSubscriptionAndProjects } from "../../API/Subscription/SubscriptionHelper";
import moment from "moment";

class RecycleBin extends Component {

    static contextType = MsalContext;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            redirect: false,
            showDeletePopup: false,
            toDeleteProject: {},
            toRestoreProject: {},
            showRestorePopup: false,
            ProjectDeleting: false,
            projects: [],
            AllProjects: [],
            ProjectRestoring: false,
            showUpgradeDailog: false,
            showNoAccess: false,
            errorMessage: {
                status: "",
                message: "",
            },
        };
    }

    componentDidMount = async () => {
        await this.getProject();
    };

    render() {
        const { t } = this.props;
        if (this.state.redirect) return <Navigate to={"/" + this.props.organization.orgName + "/" + this.state.toRestoreProject.name + "/Entities"} />

        if (this.state.loading) return <Loader />

        if (this.state.showNoAccess) return <NoAccessComponent />

        return (
            <PageContainer>
                <div className="ps-4 my-3">
                    <h6 className="mt-2 text-muted">
                        {t("header.description")}
                    </h6>
                </div>
                <Content>
                    <Scrollable>
                        <div>
                            {
                                this.state.showUpgradeDailog && (
                                    <Upgarde
                                        organization={this.props.organization}
                                        Headline={'Need to build <br/>more apps? '}
                                        toggleDialog={this.toggleUpgradeDailog}
                                        Type={'Pro'}
                                    />
                                )
                            }
                            {this.state.showRestorePopup && (
                                <SaveDialog
                                    showLoader={this.state.ProjectRestoring}
                                    onCancel={this.handleCloseShowRestoreDataPopup}
                                    onSave={this.UpdateProjects}
                                    toggleSaveDialog={this.handleCloseShowRestoreDataPopup}
                                    errorMessage={this.state.errorMessage}
                                    message={t("restore_dialog.warning", { appName: this.state.toRestoreProject.name })}
                                    Title={t("restore_dialog.title")}
                                    SaveButtonText={t("restore_dialog.buttons.restore_button_label")}
                                    cancelButtonText={t("restore_dialog.buttons.cancel_button_label")}
                                />
                            )}
                            {this.state.showDeletePopup && (
                                <RemoveDialog
                                    showLoader={this.state.ProjectDeleting}
                                    toggleDeleteDialog={this.handleShowDeletePopup}
                                    errorMessage={this.state.errorMessage}
                                    onDelete={this.DeleteProject}
                                    message={t("delete_dialog.warning", { appName: this.state.toDeleteProject.name })}
                                    Title={t("delete_dialog.title")}
                                    deleteButtonText={t("delete_dialog.buttons.delete_button_label")}
                                    cancelButtonText={t("delete_dialog.buttons.cancel_button_label")}
                                />
                            )}
                            {this.state.projects.length === 0 && (
                                <NoRecord message={t("grid.no_data")} />
                            )}
                            {this.state.projects.length > 0 && (
                                <Grid
                                    reorderable={true}
                                    data={this.state.projects}
                                    style={{ height: "100%" }}
                                >
                                    <Column width={40} title="#" field="indexId" />
                                    <Column
                                        title={t("grid.header.app_name")}
                                        cell={(props) => {
                                            return (
                                                <td title={props.dataItem.name}>
                                                    <span
                                                        style={{ backgroundColor: props.dataItem.bgColor, }}
                                                        className="p-2 recycle-app-icon d-center rounded d-inline-block">
                                                        <i className={props.dataItem.Icon + " text-white"} ></i>
                                                    </span>
                                                    <span className="mx-2">
                                                        {props.dataItem.name}
                                                    </span>
                                                </td>
                                            );
                                        }}
                                    />
                                    <Column
                                        title={t("grid.header.deleted_by")}
                                        cell={(props) => {
                                            return props.dataItem.deletedByUser ? (
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <div
                                                            className="me-2 circle text-truncate"
                                                            style={{ backgroundColor: props.dataItem.deletedByUser.bgColor }}>
                                                            {`${props.dataItem.deletedByUser.firstName.substr(0, 1).toUpperCase()}${props.dataItem.deletedByUser.lastName.substr(0, 1).toUpperCase()}`}
                                                        </div>
                                                        <div className="text-truncate">
                                                            <h6 className="text-truncate">{props.dataItem.deletedByUser.displayName}</h6>
                                                            {props.dataItem.deletedByUser.email}
                                                        </div>
                                                    </div>
                                                </td>
                                            ) : (<td></td>)
                                        }}
                                    />
                                    <Column title={t("grid.header.deleted_on")} field="deleteOn" />
                                    <Column
                                        title={t("grid.header.app_role")}
                                        cell={(props) => {
                                            return (
                                                <td>
                                                    {props.dataItem.runtimeRights.roleName}
                                                </td>
                                            );
                                        }}
                                    />
                                    <Column
                                        title=""
                                        cell={(props) => {
                                            return (props.dataItem.runtimeRights.appGeneralSettings) ? (
                                                <td className="float-end pe-3">
                                                    <button
                                                        onClick={() => this.handleShowRestoreDataPopup(props.dataItem)}
                                                        className="me-2 btn btn-primary"
                                                    >
                                                        {t("grid.buttons.restore_button_label")}
                                                    </button>

                                                    <button
                                                        onClick={() => this.handleShowDeletePopup(props.dataItem)}
                                                        className="btn btn-secondary">
                                                        <i className="fas fa-trash-alt me-1"></i>{t("grid.buttons.delete_button_label")}
                                                    </button>
                                                </td>
                                            ) : (
                                                <td></td>
                                            );
                                        }}
                                    />
                                </Grid>
                            )}
                        </div>
                    </Scrollable>
                </Content>
            </PageContainer >
        );
    }

    getProject = async () => {
        let result = await getOrganisationProjects(this.props.organization._id);
        let runtimeResponse = await getAppUserAndRoles(this.props.organization._id);
        let runtimeRights = runtimeResponse.data
        result = this.filterProjectsBasedonRuntimeRights(result, runtimeRights);
        const organizationUsers = await getOrganizationUsers(this.props.organization._id);
        if (organizationUsers.status === "unauthorized") {
            this.setState({ showNoAccess: true, loading: false })
            return;
        }
        for (let i = 0; i < result.length; i++) {
            result[i].deleteOn = moment(result[i].deletedOn).format("LLL");
        }
        let deletedProjects = result.filter(project => project.isActive === false);
        for (let i = 0; i < deletedProjects.length; i++) {
            const deletedByOrgUser = organizationUsers.find(user => user._id === deletedProjects[i].deletedBy);
            if (deletedByOrgUser) {
                deletedByOrgUser.firstName = deletedByOrgUser.firstName || "";
                deletedByOrgUser.lastName = deletedByOrgUser.lastName || "";
                deletedByOrgUser.displayName = deletedByOrgUser.displayName || "";
            }
            deletedProjects[i].indexId = i + 1;
            deletedProjects[i].deletedByUser = deletedByOrgUser || null;
        }
        this.setState({
            AllProjects: result,
            projects: deletedProjects,
            loading: false,
        });
    };

    filterProjectsBasedonRuntimeRights = (projects, runtimeRights) => {
        let filteredProjects = [];
        for (let i = 0; i < projects.length; i++) {
            let project = projects[i];
            let instances = project.instances;
            let runtimeProject = runtimeRights.find(data => instances.find(instance => instance._id === data.appId));
            let userBelongsToProject = runtimeProject && runtimeProject.userRoles.find(userRole => userRole.userId === this.props.user.azureId);
            if (userBelongsToProject) {
                filteredProjects.push({
                    ...project,
                    runtimeRights: userBelongsToProject
                });
            }
        }
        return filteredProjects;
    }

    toggleUpgradeDailog = () => {
        this.setState({
            showUpgradeDailog: !this.state.showUpgradeDailog
        })
    }

    handleShowDeletePopup = (dataItem) => {
        this.setState({
            showDeletePopup: !this.state.showDeletePopup,
            toDeleteProject: !this.state.showDeletePopup ? dataItem : {},
        });
    };

    handleShowRestoreDataPopup = (dataItem) => {
        this.setState({
            ProjectRestoring: false,
            errorMessage: {
                status: "",
                message: "",
            },
            showRestorePopup: !this.state.showRestorePopup,
            toRestoreProject: !this.state.showRestorePopup ? dataItem : {},
        });
    };

    handleCloseShowRestoreDataPopup = () => {
        this.setState({
            errorMessage: {
                status: "",
                message: "",
            },
            ProjectRestoring: false,
            showRestorePopup: false,
            toRestoreProject: {},
        });
    };

    UpdateProjects = async () => {
        let response = await getSubscriptionAndProjects(this.props.organization._id);
        if (response.numberofApps && response.numberofApps.low >= parseInt(response.maxApps)) {
            this.setState({
                showRestorePopup: false,
                errorMessage: {
                    status: "",
                    message: "",
                },
                ProjectRestoring: false,
                toRestoreProject: {},
                showUpgradeDailog: true
            });
        } else {
            this.setState({
                errorMessage: {
                    status: "",
                    message: "",
                },
                ProjectRestoring: true,
            });

            let { errorMessage } = this.state;

            for (let instance of this.state.toRestoreProject.instances) {
                let url = this.state.toRestoreProject.name.replace(/[^a-zA-Z0-9\~\_\-\.]/g, "") + "_" + instance._id.slice(0, 5);
                let result = await enabledisableOnRuntime(
                    this.context,
                    "Application",
                    url,
                    this.props.organization._id,
                    instance._id,
                    null,
                    false
                );

                if (result.status === undefined) {
                    errorMessage.status = "Failure";
                    errorMessage.message = result.message;
                    this.setState({
                        errorMessage: errorMessage,
                        ProjectRestoring: false,
                    });
                    return;
                }
            }

            await updateProject(this.state.toRestoreProject._id, { isActive: true });

            if (this.props.isAccessedInIframe) {
                const projectUrl = this.state.toRestoreProject.name.replace(/[^a-zA-Z0-9\~\_\-\.]/g, "") + "_" + this.state.toRestoreProject.instances[0]._id.slice(0, 5);
                postMessageToRuntime({
                    reload: true,
                    projectUrl: projectUrl,
                })
                const projects = this.state.projects.filter(project => project._id !== this.state.toRestoreProject._id)
                this.setState({
                    ProjectRestoring: false,
                    showRestorePopup: false,
                    toRestoreProject: {},
                    projects: projects,
                    AllProjects: projects
                })
            } else {
                this.setState({
                    redirect: true,
                });
            }
        }
    };

    DeleteProject = async () => {
        this.setState({
            errorMessage: {
                status: "",
                message: "",
            },
            ProjectDeleting: true,
        });

        let { errorMessage } = this.state;

        for (let instance of this.state.toDeleteProject.instances) {
            let url = this.state.toDeleteProject.name.replace(/[^a-zA-Z0-9\~\_\-\.]/g, "") + "_" + instance._id.slice(0, 5);
            let result = await deleteOnRuntime(
                "Application",
                url,
                this.props.organization._id,
                instance._id,
                null,
            );

            if (result.status === undefined) {
                errorMessage.status = "Failure";
                errorMessage.message = result.message;
                this.setState({
                    errorMessage: errorMessage,
                    ProjectDeleting: false,
                });
                return;
            }
        }

        let projectDeleteResponse = await deleteProject(this.state.toDeleteProject._id);

        let projects = this.state.projects;

        projects = projects.filter((project) => project._id !== this.state.toDeleteProject._id);

        for (let i = 0; i < projects.length; i++) {
            projects[i].indexId = i + 1;
        }
        if (projectDeleteResponse.status === "Success") {
            let path = this.props.organization._id + "/" + this.state.toDeleteProject._id;
            deleteDirectory(path, this.state.toDeleteProject._id);
            this.setState({
                ProjectDeleting: false,
                projects: [...projects],
                showDeletePopup: false,
                toDeleteProject: {},
            });
        } else {
            alert("Something Went Wrong");
        }
    };
}

export default withTranslation([
    "recyclebin/common",
], {
    withRef: true
})(RecycleBin);
